var _defs, _circle, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlueHrt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ecf4fc;}.b{fill:#208ce1;}.c{fill:#fff;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 34.5,
    cy: 34.5,
    r: 34.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M29.438,4.2a8.708,8.708,0,0,0-11.882.866L16.3,6.357,15.047,5.064A8.707,8.707,0,0,0,3.165,4.2a9.143,9.143,0,0,0-.63,13.238L14.856,30.159a2,2,0,0,0,2.885,0L30.062,17.437A9.138,9.138,0,0,0,29.438,4.2Z",
    transform: "translate(17.721 18.966)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.379 29.882)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 2.798,
    height: 9.327,
    transform: "translate(3.264)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 2.798,
    height: 9.327,
    transform: "translate(9.327 3.264) rotate(90)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueHrt);
export default __webpack_public_path__ + "static/media/blue_hrt.630f930a8a128c666fe5871be77c0ba5.svg";
export { ForwardRef as ReactComponent };